import React from 'react';
import { DraggableDialog } from '@hobs/components/Dialog';
import { GhostButton, RaisedButton } from '@hobs/components/Buttons';

import './ConfirmActionDialog.scss';

const ConfirmActionDialog = ({
  title,
  onConfirm,
  onCancel,
  text,
  confirmText,
  cancelText,
  isDialogOpen
}) => {
  return (
    <DraggableDialog
      isOpen={isDialogOpen}
      title={title}
      className={'confirmation-dialog'}
      onClose={onCancel}
    >
      <span className="text">{text}</span>
      <div className="response--dialog--button">
        <GhostButton onClick={onCancel}>{cancelText}</GhostButton>
        <RaisedButton onClick={onConfirm}>{confirmText}</RaisedButton>
      </div>
    </DraggableDialog>
  );
};

ConfirmActionDialog.defaultProps = {
  confirmText: 'Yes',
  cancelText: 'No'
};

export default ConfirmActionDialog;
